import { getWebBaseURL } from '../getWebBaseURL';

export const convertDeeplinkToWebLink = async (
  deeplink: string,
): Promise<string | null> => {
  if (deeplink.includes('ably://webview')) {
    const url = extractWebviewUrl(deeplink);
    if (url == null) return null;
    if (url.startsWith('http')) return url;
    const baseURL = await getWebBaseURL();
    return `${baseURL}/${url.replace(/^\//, '')}`;
  }

  const routePath = getRoutePath(deeplink);
  if (routePath === null) return null;

  const baseURL = await getWebBaseURL();
  return `${baseURL}${routePath}`;
};

const getRoutePath = (deeplink: string): string | null => {
  if (deeplink.includes('ably://screens')) {
    const searchParams = new URLSearchParams(deeplink.split('?')[1]);
    return `/screens?${searchParams.toString()}`;
  }

  if (deeplink.includes('ably://events')) {
    const eventSno = deeplink.split('events/')[1];
    return `/events/${eventSno ?? ''}`;
  }

  if (deeplink.includes('ably://markets')) {
    const marketSegment = deeplink.split('markets/')[1];
    const [path, query] = marketSegment.split('?');
    return query != null
      ? `/mobile/markets/${path}?${query}`
      : `/mobile/markets/${path}`;
  }

  if (deeplink.includes('ably://goods')) {
    const goodsSegment = deeplink.split('goods/')[1];
    const [path, query] = goodsSegment.split('?');
    return query != null ? `/goods/${path}?${query}` : `/goods/${path}`;
  }

  return null;
};

/**
 * ably://webview 딥링크에서 url= 파라미터를 추출합니다.
 * url 값은 encodeURIComponent로 인코딩되어 있어야 URLSearchParams가 정확히 파싱합니다.
 */
const extractWebviewUrl = (deeplink: string): string | null => {
  const queryPart = deeplink.split('?').slice(1).join('?');
  const params = new URLSearchParams(queryPart);
  return params.get('url');
};
